// Snippet para mostrar variantes de cadena como siblings - Digital Thinking 
// JS para cambiar la tarjeta del producto vía AJAX
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sibling-variant-button').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const url = this.getAttribute('href');
      fetch(url + '&view=card')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCard = doc.querySelector('.product-card');
          this.closest('.product-card').replaceWith(newCard);
        });
    });
  });
});
